module.exports = __webpack_public_path__ + "static/media/bus-icon-out.b1d15a45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-icon-out.svg
// module id = 665
// module chunks = 0